import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { FilledTextArea } from "./CalculatorStyled";
const textSx = {
    backgroundColor: "background.default",
    color: "text.primary",
    fontSize: "32px",
    margin: "0",
    resize: "none",
    border: "none",
    textAlign: "right",
    minHeight: "0",
};
export default memo((props) => {
    return (_jsx(FilledTextArea, { sx: textSx, style: useMemo(() => ({ opacity: props.opacity }), [props.opacity]), readOnly: true, ref: props.textRef, defaultValue: props.defaultValue, value: props.value }));
});
